/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { AreaSplineChartLoading } from '../../../CommonComponents/OPL/charts/AreaSplineChart/AreaSplineChart.loading';
import { useAmountInvestedChart } from '../../hooks/useAmountInvestedChart';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { ValueVsInvestmentChartContent } from './components/ValueVsInvestmentChartContent/ValueVsInvestmentChartContent';

interface ValueVsInvestmentChartProps {
  portfolioReturn: number | null;
  setSelectedDate(date: string | null): void;
}

export const ValueVsInvestmentChart = ({
  portfolioReturn,
  setSelectedDate,
}: ValueVsInvestmentChartProps) => {
  const { isFetching, isError, refetch, data } = useAmountInvestedChart();
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isFetching) {
    return (
      <AreaSplineChartLoading
        containerProps={{ style: { height: isEmbeddedMobile ? '280px' : 'unset' } }}
      />
    );
  }

  if (isError) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={isEmbeddedMobile ? '48' : undefined}
        height="100%"
      >
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={isEmbeddedMobile ? '24' : undefined}
      >
        <EmptyState />
      </Box>
    );
  }

  return (
    <ValueVsInvestmentChartContent
      data={data}
      portfolioReturn={portfolioReturn}
      setSelectedDate={setSelectedDate}
    />
  );
};
